const color = (
  fieldName: string,
  label: string,
  defaultValue: string,
  extra: Record<string, unknown> = {},
) => ({
  fieldName,
  label,
  value: defaultValue,
  valueType: "string",
  filedType: "COLOR",
  placeholder: defaultValue,
  required: false,
  defaultValue,
  ...extra,
});

const toggle = (
  fieldName: string,
  label: string,
  placeholder: string,
  defaultValue: boolean,
) => ({
  fieldName,
  label,
  value: defaultValue,
  valueType: "boolean",
  filedType: "TOGGLE",
  placeholder,
  required: false,
  defaultValue,
});

/**
 * Author Card 1 (section 3003 / variant 3000).
 *
 * There are NO content fields on purpose: the photo, name, article count and bio
 * are all read from the author linked to the blog page, so editing that author in
 * Author Management updates every page it appears on. Only presentation is stored.
 */
export const AUTHOR_CARD_1_CONSTANTS = {
  AUTHOR_CARD_FIELDS_CONFIG: [
    {
      // TEXT_BLOCK is display-only and never persisted — it renders in bold so the
      // rendering rule is impossible to miss while configuring the widget.
      fieldName: "render_rule_note",
      label: "Where this widget appears",
      filedType: "TEXT_BLOCK",
      description:
        "This widget is rendered ONLY when the page type is Blog AND an author is linked to the page. On any other page, or on a blog with no author linked, it renders nothing. Link the author in the page settings (Link Author). All content — photo, name, article count and bio — comes from that author.",
      fullWidth: true,
    },

    color("background_color", "Background Color", "#FFFFFF"),
    color("author_name_color", "Author Name Color", "#342B7C"),
    color("meta_text_color", "Articles Published Text Color", "rgba(0,0,0,0.6)"),
    color("description_text_color", "Bio Text Color", "#000000"),

    toggle(
      "show_author_link",
      "Link Author Name To Profile",
      "Off shows the name as plain text. The link uses the author's profile page path, or '#' when they have none",
      true,
    ),

    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [],
};
